export const sortCurrenciesByArray = (a, b, array) => {
  const index1 = array.indexOf(a.name),
    index2 = array.indexOf(b.name);
  return (index1 > -1 ? index1 : Infinity) - (index2 > -1 ? index2 : Infinity);
};
//# sourceMappingURL=sortCurrenciesByArray.js.map
// @zapier/checkout@7.9.7 (23abc9ace)
